import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions';

class VideoDocumentListItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                {this.props.user}
            </div>
        );
    }
}

const mapStateToProps = ({ client }) => {
    return {
        userData: client.clientData
    };
};

export default VideoDocumentListItem;


// WEBPACK FOOTER //
// ./src/js/components/VideoDocumentSharing/VideoDocumentListItem.jsx